var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h2',{staticClass:"title"},[_vm._v("Nie znaleziono")]),_c('p',[_vm._v(" Podana strona nie istnieje. Sprawdź dokładnie adres URL. ")])])
}]

export { render, staticRenderFns }